import { useApiAdvanced } from "ApiHooks"
import ModalVistaPreviaPDF from "Components/ModalVistaPreviaPDF"
import { useBlockUI } from "Context/BlockUIContext"
import React, { useEffect, useState } from "react"
import {
    Container,
    Row,
    Col,
    Form,
    Button,
    Card
} from "react-bootstrap"
import { isCuitValido, isValidDestinacion } from "utils/Utils"

const FormularioF2241 = () => {

    const api = useApiAdvanced()
    const { showBlock, hideBlock } = useBlockUI()

    const [canales, setCanales] = useState<string[]>([])
    const [tiposDocumentos, setTiposDocumentos] = useState([])
    const [tramites, setTramites] = useState<string[]>([])
    const [secuencias, setSecuencias] = useState<string[]>([])
    const [mensajeValidacion, setMensajeValidacion] = useState('')
    const [showModalVistaPreviaPDF, setShowModalVistaPreviaPDF] = useState(false)
    const [base64PDF, setBase64PDF] = useState(null)
    const [nombrePDF, setNombrePDF] = useState('')
    const initialCamposHabilitados = {
        CuitImpExpTFEnabled: false,
        DestinacionTFEnabled: false,
        TipoDocumentoCBEnabled: false,
        NuevoDocTFEnabled: false,
        TicketTFEnabled: false,
        NumeroActSIGEATextFieldEnabled: false,
        NotaTextAreaEnabled: false,
        FamiliaCBEnabled: false,
        PlusButtonEnabled: false,
        SecuenciaEnvioCBEnabled: false
    }
    const initialFormData = {
        canalIngreso: "WSE o PSAD",
        tramiteSolicitado: "",
        familia: "",
        secuenciaEnvio: "Final",

        cuitDeclarante: "",
        cuitImpExp: "",
        destinacion: "",

        tipoDocumento: "",
        nuevoDoc: "",
        ticket: "",

        areaSIGEA: "",
        numeroActSIGEA: "",
        anioSIGEA: "",

        nota: "",

        PresentacionComplementariaChecked: false
    }
    const [camposHabilitados, setCamposHabilitados] =
        useState(initialCamposHabilitados)
    const [formData, setFormData] = useState(initialFormData)

    const handleGenerar = async () => {
        setMensajeValidacion('')
        showBlock('Generando PDF..')
        const payload = {
            canalDeIngreso: formData.canalIngreso,
            tramiteSolicitado: formData.tramiteSolicitado,
            cuitDeclarante: formData.cuitDeclarante,
            cuitImpExp: formData.cuitImpExp,
            destinacion: formData.destinacion,
            nota: formData.nota,
            archivosAdjuntosCount: 0,
            secuenciaEnvio: formData.secuenciaEnvio,
            tipoDocumento: formData.tipoDocumento,
            nuevoDoc: formData.nuevoDoc,
            ticket: null,
            areaSIGEA: null,
            numeroActSIGEA: null,
            anioSIGEA: null,
            familia: null,
            AnioSIGEAText: null,
            AreaSIGEAText: null,
            NumeroActSIGEATextFieldText: null,
            ...camposHabilitados
        }
        try {
            let respValidacion = await api.validarCampos(payload)
            if (!respValidacion?.Exito) {
                hideBlock()
                return setMensajeValidacion(respValidacion?.Mensaje)
            }
            const pdfBlob = await api.generarPDF2441(
                payload
            )
            setBase64PDF(pdfBlob?.Base64)
            setNombrePDF(pdfBlob?.NombrePDF)
            setFormData(initialFormData)
            setCamposHabilitados(initialCamposHabilitados)
            setSecuencias([])
            setShowModalVistaPreviaPDF(true)
        } catch (error: any) {
            alert(
                error?.response?.data?.message ||
                "Error al generar PDF"
            )
            hideBlock()
        } finally {
            hideBlock()
        }
    }
    const cargarCanales = async () => {
        showBlock('Cargando canales..')
        try {
            const response = await api.getCanales()
            setCanales(response)
        } catch (error: any) {
            alert(
                error?.response?.data?.message ||
                "Error"
            )
        } finally {
            hideBlock()
        }
    }

    const cargarTramites = async () => {
        showBlock('Cargando tramites..')
        try {
            const response = await api.getTramites(
                formData.canalIngreso
            )
            setTramites(response)
            setSecuencias([])
            setFormData(prev => ({
                ...prev,
                tramiteSolicitado: "",
                familia: "",
                secuenciaEnvio: ""
            }))
        } catch (error: any) {
            alert(
                error?.response?.data?.message ||
                "Error"
            )
        } finally {
            hideBlock()

        }
    }

    const cargarSecuencias = async () => {
        showBlock('Cargando secuencias..')
        try {
            const response = await api.getSecuencias(
                formData.canalIngreso,
                formData.tramiteSolicitado
            )

            setSecuencias(response)
        } catch (error: any) {
            alert(
                error?.response?.data?.message ||
                "Error"
            )
        } finally {
            hideBlock()

        }
    }

    const cargarTiposDocumentos = async () => {
        showBlock('Cargando tipos de documentos..')
        try {
            const response = await api.getTiposDocumentos()
            setTiposDocumentos(response)
        } catch (error: any) {
            alert(
                error?.response?.data?.message ||
                "Error"
            )
        } finally {
            hideBlock()
        }
    }

    const obtenerCamposHabilitados = async () => {
        showBlock('Cargando campos habilitados..')
        try {
            const response = await api.getCamposHabilitados({
                canalDeIngreso: formData.canalIngreso,
                tramiteSolicitado:
                    formData.tramiteSolicitado,
                tipoDocumento:
                    formData.tipoDocumento?.length > 0 ? formData.tipoDocumento : null,
                PresentacionComplementariaChecked:
                    formData.PresentacionComplementariaChecked
            })

            const camposALimpiar: Partial<typeof formData> = {}

            if (camposHabilitados.CuitImpExpTFEnabled && !response.CuitImpExpTFEnabled)
                camposALimpiar.cuitImpExp = ''
            if (camposHabilitados.DestinacionTFEnabled && !response.DestinacionTFEnabled)
                camposALimpiar.destinacion = ''
            if (camposHabilitados.TipoDocumentoCBEnabled && !response.TipoDocumentoCBEnabled)
                camposALimpiar.tipoDocumento = ''
            if (camposHabilitados.NuevoDocTFEnabled && !response.NuevoDocTFEnabled)
                camposALimpiar.nuevoDoc = ''
            if (camposHabilitados.TicketTFEnabled && !response.TicketTFEnabled)
                camposALimpiar.ticket = ''
            if (camposHabilitados.NumeroActSIGEATextFieldEnabled && !response.NumeroActSIGEATextFieldEnabled) {
                camposALimpiar.numeroActSIGEA = ''
                camposALimpiar.areaSIGEA = ''
                camposALimpiar.anioSIGEA = ''
            }
            if (camposHabilitados.NotaTextAreaEnabled && !response.NotaTextAreaEnabled)
                camposALimpiar.nota = ''
            if (camposHabilitados.FamiliaCBEnabled && !response.FamiliaCBEnabled)
                camposALimpiar.familia = ''
            if (camposHabilitados.SecuenciaEnvioCBEnabled && !response.SecuenciaEnvioCBEnabled)
                camposALimpiar.secuenciaEnvio = ''

            if (Object.keys(camposALimpiar).length > 0)
                setFormData(prev => ({ ...prev, ...camposALimpiar }))

            setCamposHabilitados(response)
        } catch (error: any) {
            alert(
                error?.response?.data?.message ||
                "Error"
            )
        } finally {
            hideBlock()

        }
    }

    const cuitDeclaranteValido =
        formData.cuitDeclarante.trim().length > 0 &&
        isCuitValido(formData.cuitDeclarante)

    const cuitImpExpValido =
        !camposHabilitados.CuitImpExpTFEnabled ||
        (
            formData.cuitImpExp.trim().length > 0 &&
            isCuitValido(formData.cuitImpExp)
        )

    const destinacionValida =
        !camposHabilitados.DestinacionTFEnabled ||
        (
            formData.destinacion.trim().length > 0 &&
            isValidDestinacion(formData.destinacion)
        )

    const formularioValido =
        cuitDeclaranteValido &&
        cuitImpExpValido &&
        destinacionValida

    useEffect(() => {
        cargarCanales()
        //eslint-disable-next-line    
    }, [])

    useEffect(() => {
        if (!formData.canalIngreso) return

        cargarTramites()
        //eslint-disable-next-line    
    }, [formData.canalIngreso])

    useEffect(() => {
        if (
            !formData.canalIngreso ||
            !formData.tramiteSolicitado
        )
            return

        cargarSecuencias()
        obtenerCamposHabilitados()
        //eslint-disable-next-line    
    }, [
        formData.canalIngreso,
        formData.tramiteSolicitado,
        formData.tipoDocumento,
        formData.PresentacionComplementariaChecked
    ])

    useEffect(() => {
        if (
            secuencias.length > 0 &&
            secuencias.includes("Final") &&
            !formData.secuenciaEnvio
        ) {
            setFormData(prev => ({
                ...prev,
                secuenciaEnvio: "Final"
            }))
        }
        //eslint-disable-next-line       
    }, [secuencias])

    useEffect(() => {
        if (camposHabilitados.TipoDocumentoCBEnabled) {
            cargarTiposDocumentos()
        }
        //eslint-disable-next-line    
    }, [camposHabilitados.TipoDocumentoCBEnabled])


    return (
        <Container fluid className="py-4 bg-light min-vh-100">
            <Row className="justify-content-center">
                <Col md={8} lg={7}>
                    <Card className="border-0 shadow-sm">
                        <Card.Body className="p-4">
                            <h4 className="font-weight-bold">
                                Formulario F3101/F2241
                            </h4>

                            <h5 className="text-muted mb-4">
                                Sistema OSIRIS - AFIP DIT
                            </h5>

                            <Form>
                                <Form.Group as={Row}>
                                    <Form.Label column sm={4}>
                                        Canal de Ingreso:
                                    </Form.Label>

                                    <Col sm={8}>
                                        <Form.Control
                                            as="select"
                                            value={formData?.canalIngreso}
                                            disabled
                                            defaultValue={"WSE o PSAD"}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    canalIngreso: value
                                                }))
                                            }}
                                        >
                                            <option value="">
                                                Seleccionar
                                            </option>

                                            {canales?.map((canal) => (
                                                <option
                                                    key={canal}
                                                    value={canal}
                                                >
                                                    {canal}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row}>
                                    <Form.Label column sm={4}>
                                        Trámite Solicitado:
                                    </Form.Label>

                                    <Col sm={8}>
                                        <Form.Control
                                            as="select"
                                            value={
                                                formData.tramiteSolicitado
                                            }
                                            onChange={(e) => {
                                                const value = e.target.value

                                                setFormData((prev) => ({
                                                    ...prev,
                                                    tramiteSolicitado: value
                                                }))
                                            }
                                            }
                                        >
                                            <option value="">
                                                Seleccionar
                                            </option>

                                            {tramites.map((tramite) => (
                                                <option
                                                    key={tramite}
                                                    value={tramite}
                                                >
                                                    {tramite}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row}>
                                    <Form.Label column sm={4}>
                                        CUIT Declarante:
                                    </Form.Label>

                                    <Col sm={8}>
                                        <Form.Control
                                            type="text"
                                            value={
                                                formData.cuitDeclarante
                                            }
                                            onChange={(e) => {
                                                const value = e.target.value
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    cuitDeclarante: value
                                                }))
                                            }}
                                            isInvalid={
                                                formData.cuitDeclarante.length > 0 &&
                                                !isCuitValido(formData.cuitDeclarante)
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            CUIT inválido.
                                        </Form.Control.Feedback>
                                        <Form.Text className="text-muted">
                                            Ingrese el CUIT sin guiones (00123456780).
                                        </Form.Text>
                                    </Col>


                                </Form.Group>

                                <Form.Group as={Row}>
                                    <Form.Label column sm={4}>
                                        CUIT Importador/Exportador:
                                    </Form.Label>

                                    <Col sm={8}>
                                        <Form.Control
                                            type="text"
                                            disabled={
                                                !camposHabilitados.CuitImpExpTFEnabled
                                            }
                                            value={formData.cuitImpExp}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    cuitImpExp: value
                                                }))
                                            }}
                                            isInvalid={
                                                formData.cuitImpExp.length > 0 &&
                                                !isCuitValido(formData.cuitImpExp)
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            CUIT inválido.
                                        </Form.Control.Feedback>
                                        <Form.Text className="text-muted">
                                            Ingrese el CUIT sin guiones (00123456780).
                                        </Form.Text>
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row}>
                                    <Form.Label column sm={4}>
                                        Destinación:
                                    </Form.Label>

                                    <Col sm={8}>
                                        <Form.Control
                                            type="text"
                                            isInvalid={
                                                formData.destinacion.length > 0 &&
                                                !isValidDestinacion(formData.destinacion)
                                            }
                                            disabled={!camposHabilitados.DestinacionTFEnabled}
                                            value={formData.destinacion}
                                            onChange={(e) => {
                                                const value = e.target.value

                                                setFormData((prev) => ({
                                                    ...prev,
                                                    destinacion: value
                                                }))
                                            }}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            La destinación ingresada no es válida.
                                        </Form.Control.Feedback>
                                        <Form.Text className="text-muted">
                                            Ingrese una destinación válida (24008IC04005403M).
                                        </Form.Text>
                                    </Col>

                                </Form.Group>

                                <Form.Group as={Row}>
                                    <Form.Label column sm={4}>
                                        Notas:
                                    </Form.Label>

                                    <Col sm={8}>
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            disabled={
                                                !camposHabilitados.NotaTextAreaEnabled
                                            }
                                            value={formData.nota}
                                            onChange={(e) => {
                                                const value = e.target.value

                                                setFormData((prev) => ({
                                                    ...prev,
                                                    nota: value
                                                }))
                                            }
                                            }
                                        />
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row}>
                                    <Form.Label column sm={4}>
                                        Código Documento:
                                    </Form.Label>

                                    <Col sm={8}>
                                        <Form.Control
                                            as="select"
                                            value={formData?.tipoDocumento ?? ''}
                                            disabled={
                                                !camposHabilitados.TipoDocumentoCBEnabled
                                            }
                                            onChange={(e) => {
                                                const value = e.target.value
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    tipoDocumento: value,
                                                    nuevoDoc: ""
                                                }))
                                            }}
                                        >
                                            <option value="">
                                                Seleccionar
                                            </option>

                                            {tiposDocumentos?.map((tipoDocumento) => (
                                                <option
                                                    key={tipoDocumento}
                                                    value={tipoDocumento}
                                                >
                                                    {tipoDocumento}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row}>
                                    <Form.Label column sm={4}>
                                        Nuevo Código Documento:
                                    </Form.Label>

                                    <Col sm={8}>
                                        <Form.Control
                                            type="text"
                                            disabled={
                                                !camposHabilitados.NuevoDocTFEnabled
                                            }
                                            value={
                                                formData.nuevoDoc
                                            }
                                            onChange={(e) => {
                                                const value = e.target.value
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    nuevoDoc: value
                                                }))
                                            }}

                                        />
                                    </Col>

                                </Form.Group>
                                <Form.Group as={Row}>
                                    <Form.Label column sm={4}>
                                        Secuencia de Envío:
                                    </Form.Label>

                                    <Col sm={8}>
                                        <Form.Control
                                            as="select"
                                            disabled={
                                                !camposHabilitados.SecuenciaEnvioCBEnabled
                                            }
                                            value={
                                                formData.secuenciaEnvio
                                            }
                                            onChange={(e) => {
                                                const value = e.target.value

                                                setFormData((prev) => ({
                                                    ...prev,
                                                    secuenciaEnvio: value
                                                }))
                                            }
                                            }
                                        >
                                            <option value="">
                                                Seleccionar
                                            </option>

                                            {secuencias.map(
                                                (secuencia) => (
                                                    <option
                                                        key={
                                                            secuencia
                                                        }
                                                        value={
                                                            secuencia
                                                        }
                                                    >
                                                        {
                                                            secuencia
                                                        }
                                                    </option>
                                                )
                                            )}
                                        </Form.Control>
                                    </Col>
                                </Form.Group>
                                <Row className="mt-2">
                                    <Col className="text-center">
                                        {mensajeValidacion && <p style={{ fontSize: 20, color: 'red' }}>{mensajeValidacion}</p>}
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col className="text-center">
                                        <Button
                                            disabled={!formularioValido}
                                            variant="primary"
                                            onClick={
                                                handleGenerar
                                            }
                                        >
                                            Generar
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <ModalVistaPreviaPDF anularLoteButton={false} showModalVistaArchivo={showModalVistaPreviaPDF} nombreArchivo={nombrePDF} base64Archivo={base64PDF!} handleCloseModalVisualizarArchivo={() => {
                setShowModalVistaPreviaPDF(false)
                setBase64PDF(null)
            }} />
        </Container>
    )
}

export default FormularioF2241